import c from "../common";

export default {
  titletext: c.BBS_title.en,

  selectshop: "Select Shop:     ",
  Logout: c.Logout.en,

  //Slider
  Homepage: c.homepage.en,
  Detail: c.vendor.en.uppercase + " Detail",
  StaffMgt: "Staff Management",
  DataCenter: "Data Center",
  Voucher_And_Discount: c.voucher.en.uppercase + " & " + c.discount.en.uppercase,
  ComingSoon: c.ComingSoon.en,
  EventDetail: "Event Detail",
  Partner: "Partner",
  PaymentGateway: "Payment Gateway",
  Takeaway: c.takeaway.en.uppercase,
  language: c.language.en,
  Event: c.event.en,
  Estamp: c.estamp.en,
  RewardEvent: c.rewardEvent.en.uppercase,
  AdCarousel: "Advertisement",
  PushNotification: "Push Notification",

  Homepage2: "",
};
